import { VendorNameAutoSuggestionPanelComponent } from './custom-components/vendor-auto-suggest/vendorNameAutoSuggestionPanel';
import { ExcelConverterDirective } from './directives/helper/excel-converter.directive';
import { NgbModalModule } from './../modal/modal.module';
import { TotalPipe } from './pipes/total.pipe';
import { FilterByPipe } from './pipes/filter-by.pipe';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToolbarDirective } from './directives/styles/toolbar.directive';
import { ScrollTopBtnDirective } from './directives/styles/scroll-top-btn.directive';
import { SplitPipe } from './pipes/split.pipe';
import { FirstLetterConverterPipe } from './pipes/first-letter-converter.pipe';
import { SubMenuToggleDirective } from './directives/styles/sub-menu-toggle.directive';
import { BackBtnDirective } from './directives/styles/back-btn.directive';
import { OffcanvasToggleDirective } from './directives/styles/offcanvas-toggle.directive';
import { SiteBackdropDirective } from './directives/styles/site-backdrop.directive';
import { CloseDropdownDirective } from './directives/styles/close-dropdown.directive';
import { OwlCarouselDirective } from './directives/styles/owl-carousel.directive';
import { TextTruncatePipe } from './pipes/text-truncate.pipe';
import { ToasterDirective } from './directives/styles/toaster.directive';
import { FilterToggleDirective } from './directives/styles/filter.directive';
import { FilterSearchPipe } from './pipes/filter-search.pipe';
import { EnterKeyListenerDirective } from '@otas/utils/directives/helper/enter.directive';
import { HrefDirective } from '@otas/utils/directives/helper/href.directive';
import { ToolTipDirective } from '@otas/utils/directives/helper/tooltip.directive';
import { PasswordEqualValidatorDirective } from '@otas/utils/custom-validators/password-validators';
import { EmailValidatorDirective } from '@otas/utils/custom-validators/email-validator';
import { DateBeforeValidatorDirective } from '@otas/utils/custom-validators/date-validator';
import { ShowErrorsComponent } from '@otas/utils/custom-components/show-errors/show-errors.component';
import { TypeCheckDirective } from '@otas/utils/directives/helper/check-box-radio-button-fix';
import { InputFileDirective } from '@otas/utils/directives/helper/input-file-fix.directive';
import { FileUpload } from '@otas/utils/directives/helper/button-click-file-upload.component';
import { Principal } from '@otas/shared/auth/principal.service';
import { AuthDirective } from 'app/authenticated/auth.directive';
import { ButtonDisableDirective } from '@otas/utils/directives/helper/button-disable';
import { ClearFieldDirective } from '@otas/utils/directives/helper/clearField.directive';
import { AutoSuggestComponent } from './custom-components/auto-suggest/auto-suggest.component';
import { FormsModule } from '@angular/forms';
import { AppDatePickerComponent } from 'app/shared/ui/app-date-picker/app-date-picker.component';
import { AppCascadeSelectComponent } from 'app/shared/ui/app-cascade-select/app-cascade-select.component';
import { OffClickDirective } from '@otas/utils/directives/helper/off-click.directive';
import { AddMoreAutosuggestDirective } from '@otas/utils/directives/helper/add-more-autosuggest.directive';
import { AutoSuggestFooterDirective } from '@otas/utils/directives/helper/auto-suggest-footer.directive';
import { WidgetCatogeriesDirective } from '@otas/utils/directives/helper/widget-catogeries.directive';
import { CheckboxComponent } from '@otas/utils/custom-components/checkbox/checkbox.component';
import { RadioButtonComponent } from '@otas/utils/custom-components/radio-button/radio-button.component';
import { MultiSelectComponent } from '@otas/utils/custom-components/multi-select/multi-select.component';
import { AccountService } from '@otas/shared/auth/account.service';
import { VirtualKeyboardComponent } from '@otas/utils/custom-components/virtual-keyboard/virtual-keyboard.component';
import { OverlayPanelComponent } from '@otas/utils/custom-components/overlay-panel/overlay-panel.component';
import { DataShiftDirective } from '@otas/utils/directives/helper/data-shift.directive';
import { FocusNextDirective } from '@otas/utils/directives/helper/focus-next.directive';
import { PanchangCalendarComponent } from '@otas/utils/custom-components/panchang-calendar/panchang-calendar.component';
import { MomentModule } from 'ngx-moment';
import { GroupbyPipe } from '@otas/utils/pipes/groupby.pipe';
import { PopupDirective } from '@otas/utils/directives/helper/popup.directive';
import { LangSwitcherPipe } from '@otas/utils/pipes/lang-switcher.pipe';
import { PanchangService } from '@otas/utils/custom-components/panchang-calendar/panchang.service';
import { UniquePipe } from '@otas/utils/pipes/aviod-repatetion.pipe';
import { IpcUtilService } from '@otas/utils/directives/helper/ipc-util.service';
import { TRANSLATION_PROVIDERS } from 'translate/translations';
import { TranslateService } from 'translate/translate.service';
import { TranslatePipe } from 'translate/translate.pipe';
import { ManglishConverterDirective } from '@otas/utils/directives/manglish/manglish-converter.directive';
import { PhoneNumberDirective } from '@otas/utils/directives/helper/phone-number.directive';
import { FloatNumberDirective } from '@otas/utils/directives/helper/float-number.directive';
import { CustomFileUploadComponent } from '@otas/utils/custom-components/custom-file-upload/custom-file-upload.component';
import { FocusAlwaysDirective } from '@otas/utils/directives/helper/focus-always.directive';
import { DateTimeWidthDirective } from '@otas/utils/directives/styles/date-time-width.directive';
import { IntNumberDirective } from '@otas/utils/directives/helper/int-number.directive';
import { DateClearButtonDirective } from '@otas/utils/directives/helper/date-clear-button.directive';
import { OrderByPipe } from '@otas/utils/pipes/order-by.pipe';
import { ToggleButtonComponent } from './custom-components/toggle-button/toggle-button.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ManglishSuggestionComponent } from './custom-components/manglish-suggestion/manglish-suggestion.component';
import { ManglishWordPipe } from './custom-components/manglish-suggestion/pipe/manglish-word.pipe';
import { IndicInputDirective } from './custom-components/virtual-keyboard/indic-input.directive';
import { PunchangCalendarDirective } from './custom-components/panchang-calendar/punchang-calendar.directive';
import { NumberValidatorDirective } from './custom-validators/number-validator.directive';
import { ChooseFolderComponent } from '@otas/utils/custom-components/choose-folder/choose-folder.component';
import { PanchangCalendarViewComponent } from './custom-components/panchang-calendar/panchang-calendar-view/panchang-calendar-view.component';

const UTIL_DIRECTIVES = [
    FocusNextDirective, NumberValidatorDirective, ChooseFolderComponent,
    ToolbarDirective,
    CloseDropdownDirective,
    ScrollTopBtnDirective,
    SplitPipe,
    FirstLetterConverterPipe,
    SubMenuToggleDirective,
    BackBtnDirective,
    OffcanvasToggleDirective,
    SiteBackdropDirective,
    OwlCarouselDirective,
    ToolTipDirective, FilterByPipe,
    OrderByPipe,
    EnterKeyListenerDirective,
    TextTruncatePipe,
    UniquePipe, TotalPipe,
    ToasterDirective,
    FilterToggleDirective,
    HrefDirective,
    ClearFieldDirective,
    FilterSearchPipe,
    PasswordEqualValidatorDirective,
    EmailValidatorDirective,
    InputFileDirective, IndicInputDirective,
    AuthDirective, DateTimeWidthDirective,
    ButtonDisableDirective,
    IntNumberDirective, PunchangCalendarDirective,
    DateBeforeValidatorDirective,
    DateClearButtonDirective, ExcelConverterDirective, ManglishWordPipe,
    ToggleButtonComponent,
    TypeCheckDirective, FocusAlwaysDirective,
    FileUpload, OffClickDirective, WidgetCatogeriesDirective, OverlayPanelComponent, ManglishSuggestionComponent,
    ShowErrorsComponent, AutoSuggestFooterDirective, RadioButtonComponent, DataShiftDirective, VendorNameAutoSuggestionPanelComponent,
    CheckboxComponent, MultiSelectComponent, AddMoreAutosuggestDirective, AutoSuggestComponent, PanchangCalendarComponent,
    VirtualKeyboardComponent, GroupbyPipe, PopupDirective, LangSwitcherPipe,
    ManglishConverterDirective, PhoneNumberDirective, FloatNumberDirective, CustomFileUploadComponent, PanchangCalendarViewComponent
];

@NgModule({
    imports: [
        NgbModalModule.forRoot(),
        CommonModule, FormsModule, MomentModule, NgbModule, DragDropModule,
        // standalone shared picker — the panchang calendar view's filter bar
        // uses its period (from-to) mode
        AppDatePickerComponent,
        // standalone cascade dropdown — the same filter bar's Week-day filter
        // (weekday -> m:/e: occurrence submenu, R27b)
        AppCascadeSelectComponent
    ],
    declarations: [
        UTIL_DIRECTIVES
        , TranslatePipe,
        AutoSuggestComponent, VendorNameAutoSuggestionPanelComponent
    ],
    exports: [UTIL_DIRECTIVES, TranslatePipe, CommonModule, MomentModule,
        NgbModalModule

    ],
    providers: [

    ]
})
export class UtilsModule {
    static forRoot(): ModuleWithProviders<UtilsModule> {
        return {
            ngModule: UtilsModule,
            providers: [
                AccountService, Principal, PanchangService, IpcUtilService, TRANSLATION_PROVIDERS, TranslateService]
        };
    }
}
